import styled from 'styled-components'

export const SplitScreenOuter = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
export const SplitScreenWrapper = styled.div`
  display: flex;
  max-width: ${({ innerMax }) => innerMax || `1020px`};
  padding: ${({ pad }) => pad || `8rem 23px`};
  padding-right: 8px;
  padding-left: 8px;
  width: 100%;
  justify-content: space-between;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  align-items: center;
  @media only screen and (max-width: 1150px) {
    box-sizing: border-box;
    padding: 6rem 2rem;
    ${({ first }) => first && `padding-top: 0;`}
  }

  @media only screen and (max-width: 850px) {
    flex-direction: column;
  }

  @media only screen and (min-width: 850px) {
    .split-right {
      margin-left: ${({ innerMiddle }) => innerMiddle || `11.3333%`};
    }
  }
`

export const TextWrapper = styled.div`
  max-width: ${({ textMax }) => textMax || `448px`};
  width: 100%;
  > @media ${({ theme }) => theme.breakpoints.tablet} {
    margin: 0 auto;
  }
  @media only screen and (max-width: 1050px) {
    max-width: 45%;
  }

  @media only screen and (max-width: 850px) {
    max-width: 100%;
    padding-bottom: 4rem;
  }

  @media only screen and (max-width: 600px) {
    padding: 0 3px 5rem;
    ${({ full }) => full && `padding-top: 0`}
  }
  .subHead {
    margin-top: -0.8rem;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 30px;
    @media only screen and (max-width: 1200px) {
      font-size: 24px;
    }
    @media only screen and (max-width: 700px) {
      font-size: 20px;
    }
  }
  > h3 {
    margin: 0.6rem 0 2rem;
    font-size: 49px;
    white-space: pre-line;
    @media only screen and (max-width: 1200px) {
      font-size: 40px;
    }
    @media only screen and (max-width: 700px) {
      font-size: 30px;
    }
  }
  > p {
    ${({ textColor }) => textColor && `color: ${textColor}!important;`}
    color: #505050;
    font-size: 21px;
    font-weight: 400;
    @media only screen and (max-width: 700px) {
      font-size: 19px;
    }
  }
`

export const SplitScreenInner = styled.div``

export const ImgWrapper = styled.div`
  width: 100%;
  box-sizing: border-box;
  max-width: ${({ maxW }) => (maxW ? `${maxW}px` : 'auto')};
  max-height: ${({ maxH }) => (maxH ? `${maxH}px` : 'auto')};
  > p {
    margin-top: 23px;
    font-size: 18px;
    color: #515151;
  }
  @media only screen and (max-width: 1150px) {
    max-width: ${({ maxW }) => (maxW ? `${maxW}px` : 'auto')};
    max-height: ${({ maxH }) => (maxH ? `${maxH}px` : 'auto')};
  }

  @media only screen and (max-width: 700px) {
    ${({ noGraphicMobile }) => noGraphicMobile && 'display: none;'}
    padding: 0 3px;
  }
`

export const GraphicHead = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  > div {
    width: 100%;
    max-width: 77px;
    margin-right: 20px;
  }
  > p {
    color: rgba(33, 33, 33, 0.63);
    font-size: 23px;
    font-weight: 500;
    @media only screen and (max-width: 500px) {
      font-size: 19px;
    }
  }
`
